<template>
  <div class="container py-5">

    <button
      class="button is-primary mb-5"
      @click="addingCompany = true">
      Create a New Company
    </button>

    <article 
      v-if="companies.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There are no companies.
      </div>
    </article>

    <table v-else class="table is-fullwidth is-hoverable is-clickable">
      <thead>
        <tr>
          <th 
            v-for="(header, headerIndex) in headers"
            :key="headerIndex">
            {{ header.label }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr 
          class="v-centered"
          v-for="company in companies" 
          @click="viewCompany(company)"
          :key="company.id">
          <template v-for="(header, headerIndex) in headers">
            <td 
              v-if="header.field != 'avg_rating'"
              :key="headerIndex"
              :class="{ 'has-text-grey-light': header.subfield && !company[header.field] }">
              {{ header.subfield ? company[header.field] ?
                company[header.field][header.subfield] : 
                'N/A' : company[header.field] }}
            </td>
            <td
              v-else
              :key="headerIndex">
              <v-star-rating
                v-if="company[header.field]" 
                :value="company[header.field]">
              </v-star-rating>
              <span v-else class="has-text-grey-light">
                No rating available
              </span>
            </td>
          </template>
          <td>
            <div class="buttons buttons-right">
              <button
                @click.stop="launchConfirmDelete(company.id)" 
                class="button is-small">
                <span class="icon has-text-grey">
                  <i class="fa fa-trash"></i>
                </span>
                <span>Delete</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <add-company-modal v-model="addingCompany"/>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>
    
  </div>
</template>

<script>
import VStarRating from '@/components/base/VStarRating'
import VPagination from '@/components/base/VPagination'
import VConfirmModal from '@/components/base/VConfirmModal'

import AddCompanyModal from '@/components/ticketing/AddCompanyModal'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VStarRating, VPagination, VConfirmModal, AddCompanyModal 
  },
  data() {
    return {
      headers: [
        { label: 'Name', field: 'name' },
        { label: 'Address', field: 'address' },
        { label: 'City', field: 'city' },
        { label: 'Province', field: 'province' },
        { label: 'Postal Code', field: 'postalcode' },
        { label: 'Phone Number', field: 'phone1' },
        { label: 'Category', field: 'category', subfield: 'category' },
        { label: 'Average Rating', field: 'avg_rating' }
      ],
      addingCompany: false,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this company?',
        type: 'danger'
      },
      deleteConfirmedCb: null
    }
  },
  computed: {
    ...mapState("tickets", {
      companies: "companies", 
      pagination: "companyPagination"
    })
  },
  watch: {
    'pagination.page'(page) {
      this.getCompanies({ page: page });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("tickets", [
      "getCompanies", "deleteCompany"
    ]),
    ...mapMutations("tickets", {
      changePage: "changeCompanyPage"
    }),
    initialize() {
      this.getCompanies();
    },
    viewCompany(company) {
      this.$router.push({ 
        name: 'TicketCompanyViewer', 
        params: {
          companyId: company.id,
          company: company
        }
      });
    },
    launchConfirmDelete(id) {
      this.deleteConfirmedCb = () => {
        this.deleteCompany(id);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>